import {
  takeLatest,
  select,
  cancelled,
  call,
  put,
} from 'redux-saga/effects'

import {
  post,
  get,
} from 'helpers/RequestUtil'
import {
  updateTablesAction
} from 'containers/Entity/actions'
import {
  POST_COMMENT,
  FETCH_COMMENTS,
} from './constants'
import {
  fetchCommentsStart,
  fetchCommentsSuccess,
  fetchCommentsError,
  postCommentStart,
  postCommentSuccess,
  postCommentError,
  clearCommentList,
  updateCommentList,
  startFetchCommentAsync,
} from './actions'
import {
  commentsUsernameSelector,
} from './selectors'
import {
  fetchApproverImage
} from 'containers/Approval/ApproverSection/actions'

function* getComments(workflowId, commentType) {
  try {
    yield put(startFetchCommentAsync())
    yield put(fetchCommentsStart())

    const data = yield call(
      get,
      `/api/fulcrum/workflows/${workflowId}/comments?filter[comment_type]=${commentType}&sort=-date`
    )
    const {
      result: {
        workflow_comments: comments
      }
    } = data

    yield put(updateTablesAction(data))
    yield put(fetchCommentsSuccess(comments))
    return comments
  } catch(error) {
    yield put(fetchCommentsError(error))
  } finally {
    if (yield cancelled()) {
      yield put(clearCommentList())
    }
  }
}

function* postComment(workflowId, comment, commentType) {
  try {
    yield put(postCommentStart())
    yield call(post, 'comments', { workflowId, comment, commentType }, '/api/fulcrum/workflow/comments')
    yield put(postCommentSuccess())
  } catch(error) {
    yield put(postCommentError(error))
  }
}

function* postAndFetchComments(action) {
  const { workflowId, comment, commentType } = action
  yield call(postComment, workflowId, comment, commentType)
  yield call(fetchComments, workflowId, commentType)
}

function* fetchComments(workflowId, commentType) {
  const comments = yield call(getComments, workflowId, commentType)
  yield put(updateCommentList(comments))
  // get images
  const usernames = yield select(commentsUsernameSelector)
  for (let username of usernames) {
    yield put(fetchApproverImage(username))
  }
}

function* fetchCommentsHandler(action) {
  const { workflowId, commentType } = action
  yield call(fetchComments, workflowId, commentType)
}

function* watchFetchComments() {
  yield takeLatest(FETCH_COMMENTS, fetchCommentsHandler)
}

function* watchPostComments() {
  yield takeLatest(POST_COMMENT, postAndFetchComments)
}

export {
  watchFetchComments,
  watchPostComments,
  fetchComments,
}
